import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.42883 3.83984L13.5276 17.1048L3.98633 28.1598H6.02008L14.4288 18.4173L21.1113 28.1598H27.5201L17.9988 14.2798L27.0101 3.83984H24.9776L17.0988 12.9673L10.8376 3.83984H4.42883Z",
            fill: "white"
        })
    }));
};
export default Icon;
